import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from 'widgets/signalTiles/rsiTile/components/description/rsiTilePreview.png';

export const rsiTileDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The RSI is classified as a momentum oscillator, measuring the
                velocity and magnitude of price movements. Momentum is the rate
                of the rise or fall in price. The RSI computes momentum as the
                ratio of higher closes to lower closes: symbols which have had
                more or stronger positive changes have a higher RSI than stocks
                which have had more or stronger negative changes.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'rsi-capsule-chart-preview',
        },
    ],
};
